//@flow
import _ from "lodash";
/*
  This function take a string in the format:
  /pattern/flags
  and return a JS regex
*/

export function createRegex(regexFromSchema) {
  let matches = /\/(.*)\/(.*)/.exec(regexFromSchema);

  if (Array.isArray(matches)) {
    return new RegExp(matches[1], matches[2]);
  } else {
    return /.*/;
  }
}

export function useRegex(schema, propName) {
  if (_.has(schema, ["regex", propName])) {
    return createRegex(schema[propName].regex);
  } else {
    return null;
  }
}

export default createRegex;
